import { Button, ButtonGroup, Col,Row } from 'reactstrap';

const BoutonRetourHome = () => {
  return (
    <div>
        <div className="mb-5 mt-5 w-25 m-auto">
            <Row>
            <Col className="justify-content-end d-flex m-top-3">
                <Col className="justify-content-end">
                    <ButtonGroup className="justify-content-end d-flex">
                        <Button
                            onClick={event => window.location.href = 'https://www.eni-ecole.fr'}
                            className={"openSans btn-gradient-eni"}
                            block>Revenir à la page d'accueil
                        </Button>
                    </ButtonGroup>
                </Col>
                </Col>
            </Row>
        </div>
    </div>
  )
}

export default BoutonRetourHome